import React from 'react';
import { getColorClass } from '../../../../utils/utils';
// import { Typography } from '../../../atoms/typography/Typography';
// import CompareListSectionMobile from './compareListSectionMobile/CompareListSectionMobile';

const CompareListSection = (props) => {
  const { title, systems, renderValue } = props;

  return (
    <>
      {/* Mobile Section */}
      {/* <CompareListSectionMobile {...props} /> */}
      {/* Desktop Section */}
      <div className="flex flex-row justify-between gap-1 sm:gap-5">
        <div className="hidden lg:flex flex-1 flex-col mb-2 py-5">
          {/*
          <Typography
            fontVariant="h7"
            textAlign="left"
            className="h-9 font-bold"
          >
            {title}
          </Typography>
          */}
        </div>
        {systems.map((system, i) => (
          <div
            key={i}
            className={`flex flex-1 flex-col mb-2 p-1 sm:p-5 rounded-xl shadow-md ${getColorClass(
              i
            )}`}
          >
            {renderValue(system)}
          </div>
        ))}
      </div>
    </>
  );
};

export default CompareListSection;
